/**
 * Created by denis.gusarov on 7/13/2017.
 */
namespace Factive.Game {

    import List = Factive.Core.Linq.List;
    import Tween = Factive.Core.Tween.Tween;

    export class DiceManagerClass {
        private throwRunning: boolean;

        public diceBodyMaterial: CANNON.Material;
        public floorBodyMaterial: CANNON.Material;
        public barrierBodyMaterial: CANNON.Material;
        public world: CANNON.World;
        public scene:THREE.Scene;
        public camera:THREE.PerspectiveCamera;
        private size: number;
        public dices: Array<DiceObject> = [];

        private textures: Array<{
            value: number;
            colorTextures:Array<{texture:THREE.Texture}>;
        }> = [];

        public texture: THREE.Texture;
        private _assetScale: number;
        private textMargin: number;

        constructor(assetScale: number, public usePhongMaterial) {
            this._assetScale = assetScale;
            this.size = 1.5;
            this.textMargin = 1.0;
            this.world = new CANNON.World();
            this.world.gravity.set(0, 0, -9.82 * 20);
            this.world.broadphase = new CANNON.NaiveBroadphase();
            this.world.solver.iterations = 16;
        }

        public getTexture(value: string, colors: Array<number>){
            for (let i = 0; i < this.textures.length; i++){
                let texture = this.textures[i];
                if(texture.value.toString() == value){
                    return texture.colorTextures[colors[texture.value - 1]].texture;
                }
            }
            return null;
        }

        createTextTexture(value:number, color:number) : THREE.Texture {

            var d6_faces_labels =
                [
                    [{x: .5, y: .5}],
                    [{x: .35, y: .35}, {x: .65, y: .65}],
                    [{x: .35, y: .35}, {x: .5, y: .5}, {x: .65, y: .65}],
                    [{x: .35, y: .35}, {x: .65, y: .35}, {x: .35, y: .65}, {x: .65, y: .65}],
                    [{x: .35, y: .35}, {x: .65, y: .35}, {x: .35, y: .65}, {x: .65, y: .65}, {x: .5, y: .5}],
                    [{x: .35, y: .35}, {x: .5, y: .35}, {x: .65, y: .35}, {x: .35, y: .65}, {x: .5, y: .65}, {x: .65, y: .65}]

                ];

            var face_points_color = [
                {id: 0, palitre: ["#2E3B6D", "#2E3B6D", "#2E3B6D"]},
                {id: 1, palitre: ["#B72248", "#D72854", "#D72854"]},
                {id: 2, palitre: ["#7F35A6", "#963EC2", "#963EC2"]},
                {id: 3, palitre: ["#1A94AF", "#1FAECE", "#1FAECE"]},
                {id: 4, palitre: ["#208134", "#25983D", "#25983D"]},
                {id: 5, palitre: ["#C97B28", "#EC912F", "#EC912F"]}
            ];


            var points;
            var colors;

            if(value == 1){
                points = d6_faces_labels[0];
                colors = face_points_color[color].palitre;
            }
            if(value == 2){
                points = d6_faces_labels[1];
                colors = face_points_color[color].palitre;
            }
            if(value == 3){
                points = d6_faces_labels[2];
                colors = face_points_color[color].palitre;
            }
            if(value == 4){
                points = d6_faces_labels[3];
                colors = face_points_color[color].palitre;
            }
            if(value == 5){
                points = d6_faces_labels[4];
                colors = face_points_color[color].palitre;
            }
            if(value == 6){
                points = d6_faces_labels[5];
                colors = face_points_color[color].palitre;
            }

            if (points != null && colors != null)
            {
                var canvas = document.createElement("canvas");
                var context = canvas.getContext("2d");
                let ts = 64 * this._assetScale;
                canvas.width = canvas.height = ts;
                context.fillStyle = "#ffffff";
                context.fillRect(0, 0, canvas.width, canvas.height);

                //context.drawImage(this.FACE_TEXTURE.image, ts * .17, ts * .17, ts * .66, ts * .66);

                if (points != undefined && points != null)
                {
                    var l = points.length;

                    for (var i = 0; i < l; i++)
                    {
                        var p = points[i];

                        context.beginPath();
                        context.arc(p.x * ts, p.y * ts, 8*this._assetScale / 2, 0, 2 * Math.PI, false);
                        context.fillStyle = colors[0];
                        context.fill();

                        context.beginPath();
                        context.arc(p.x * ts, p.y * ts, 6.5*this._assetScale / 2, 0, 2 * Math.PI, false);
                        context.fillStyle = colors[1];
                        context.fill();

                        context.beginPath();
                        context.arc(p.x * ts, p.y * ts, 4*this._assetScale / 2, 0, 2 * Math.PI, false);
                        context.fillStyle = colors[2];
                        context.fill();
                    }
                }
                var texture = new THREE.Texture(canvas);
                texture.needsUpdate = true;
                texture.colorId = color;
                return texture;
            }
            else
            {
                var canvas = document.createElement("canvas");
                var context = canvas.getContext("2d");
                canvas.width = canvas.height = 16;
                context.fillStyle = "#eeeeee";
                context.fillRect(0, 0, canvas.width, canvas.height);
                var texture = new THREE.Texture(canvas);
                texture.needsUpdate = true;
                return texture;
            }

        }

        setWorld () {

            var SCREEN_WIDTH = 368 * 2,
                SCREEN_HEIGHT = 344 * 2;

            var VIEW_ANGLE = 20,
                ASPECT = SCREEN_WIDTH / SCREEN_HEIGHT,
                NEAR = 0.01,
                FAR = 20000;

            this.scene = new THREE.Scene();

            this.camera = new THREE.PerspectiveCamera( VIEW_ANGLE, ASPECT, NEAR, FAR);
            //this.scene.add(this.camera);
            this.camera.position.set(0,0,35);
            //this.camera.rotateY(Math.PI / 2);

            let ambient = new THREE.AmbientLight('#ffffff', 0.4);
            this.scene.add(ambient);

            let directionalLight = new THREE.DirectionalLight('#ffffff', 0.5);
            directionalLight.position.x = 1000;
            directionalLight.position.y = 1000;
            directionalLight.position.z = 1000;
            this.scene.add(directionalLight);

            let light = new THREE.SpotLight(0xefdfd5, 0.4);
            light.position.y = 5;
            light.position.x = -5;
            light.position.z = 25;
            light.target.position.set(0, 0, 0);
            //light.castShadow = true;
            light.shadow.camera.near = 10;
            light.shadow.camera.far = 110;
            light.shadow.camera.fov = 50;
            light.shadow.mapSize.width = 512;
            light.shadow.mapSize.height = 512;
            light.shadow.bias = 0.001;
            this.scene.add(light);

            //var floorMaterial = new THREE.MeshPhongMaterial( { color: '#113338', side: THREE.DoubleSide } );
            // var floorMaterial = new THREE.ShadowMaterial( {opacity: .2} );
            // floorMaterial.opacity = 0.25;
            // var floorGeometry = new THREE.PlaneGeometry(15, 15, 1, 1);
            // var floor = new THREE.Mesh(floorGeometry, floorMaterial);
            // floor.receiveShadow  = true;
            // floor.rotation.z = Math.PI / 2;
            // floor.position.z = -4.92;
            // this.scene.add(floor);

            this.diceBodyMaterial = new CANNON.Material("diceBodyMaterial");
            this.floorBodyMaterial = new CANNON.Material("floorBodyMaterial");
            this.barrierBodyMaterial = new CANNON.Material("barrierBodyMaterial");

            this.world.addContactMaterial(
                new CANNON.ContactMaterial(this.floorBodyMaterial,   this.diceBodyMaterial, {friction: 0.01, restitution: 0.5})
            );
            this.world.addContactMaterial(
                new CANNON.ContactMaterial(this.barrierBodyMaterial, this.diceBodyMaterial, {friction: 0, restitution: 1.0})
            );
            this.world.addContactMaterial(
                new CANNON.ContactMaterial(this.diceBodyMaterial,    this.diceBodyMaterial, {friction: 0, restitution: 0.5})
            );

            for (let i=1; i <= 6; i++)
            {
                this.textures.push({
                    value: i,
                    colorTextures: [
                        {
                            texture:this.createTextTexture(i,0)
                        },
                        {
                            texture:this.createTextTexture(i,1)
                        },
                        {
                            texture:this.createTextTexture(i,2)
                        },
                        {
                            texture:this.createTextTexture(i,3)
                        },
                        {
                            texture:this.createTextTexture(i,4)
                        },
                        {
                            texture:this.createTextTexture(i,5)
                        }
                    ]
                });
            }

            this.texture = this.createTextTexture(null,null);

            let w = 4.8;
            let h = 4.8;

            var barrier;
            barrier = new CANNON.Body({mass: 0, shape: new CANNON.Plane(), material: this.barrierBodyMaterial});
            barrier.quaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), Math.PI / 2 + Math.PI / 12);
            barrier.position.set(0, h, 0);
            this.world.addBody(barrier);

            barrier = new CANNON.Body({mass: 0, shape: new CANNON.Plane(), material: this.barrierBodyMaterial});
            barrier.quaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), -Math.PI / 2 - Math.PI / 12);
            barrier.position.set(0, -h, 0);
            this. world.addBody(barrier);

            barrier = new CANNON.Body({mass: 0, shape: new CANNON.Plane(), material: this.barrierBodyMaterial});
            barrier.quaternion.setFromAxisAngle(new CANNON.Vec3(0, 1, 0), -Math.PI / 2 - Math.PI / 12);
            barrier.position.set(w, 0, 0);
            this.world.addBody(barrier);

            barrier = new CANNON.Body({mass: 0, shape: new CANNON.Plane(), material: this.barrierBodyMaterial});
            barrier.quaternion.setFromAxisAngle(new CANNON.Vec3(0, 1, 0), Math.PI / 2 + Math.PI / 12);
            barrier.position.set(-w, 0, 0);
            this.world.addBody(barrier);

            barrier = new CANNON.Body({mass: 0, shape: new CANNON.Plane(), material: this.floorBodyMaterial});
            barrier.quaternion.setFromAxisAngle(new CANNON.Vec3(0, 0, 1), -Math.PI / 2);
            barrier.position.set(0, 0, -w);
            this.world.addBody(barrier);

            let colors = ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'];
            for (let i = 0; i < 5; i++) {
                //var die = new DiceD6({size: 1.5, backColor: colors[i]}, this.diceManager);
                //this.scene.add(die.getObject());
                this.dices.push(new DiceD6({id: i, size: 1.7, backColor: colors[i], index: i}, this));
            }

        }

        // randomDiceThrow(bag: Array<Factive.Game.DiceData>, handleRollComplete: (result:Array<DiceResultInterface>) => void, diceRollingBox: Factive.Game.DiceRollingBox) {
        //
        // }

        updatePhysics(frame_rate) {
            this.world.step(frame_rate);

            for (var i in this.dices) {
                this.dices[i].updateMeshFromBody();
            }
        }

        hideDiceByUserId(id: any) {
            let dice = this.getDiceById(id);
            dice.hide();
        }

        colorizeDice(id: any, color: number) {
            let dice;
            for(let i = 0; i < this.dices.length; i++){
                if(this.dices[i].id == id){
                    dice = this.dices[i];
                }
            }

            let l = dice.getObject().material;
            for (let j = 0; j < l.length; j++)
            {
                let material = l[j];
                material.color.set(color);
            }
        }

        showDice(id: number, value: number, color: number) {
            let dice = this.getDiceById(id);
            dice.show();
        }

        getDiceById(id)
        {
            return this.dices[id];
        }

        getDicePositionById(id)
        {
            return this.dices[id].getPosition();
        }

        prepareValues (diceValues) {
            if (this.throwRunning) throw new Error('Cannot start another throw. Please wait, till the current throw is finished.');

            for (let i = 0; i < diceValues.length; i++) {
                if (diceValues[i].value < 1 || diceValues[i].dice.values < diceValues[i].value) {
                    throw new Error('Cannot throw die to value ' + diceValues[i].value + ', because it has only ' + diceValues[i].dice.values + ' sides.');
                }
            }

            // this.throwRunning = true;
            //
            // for (let i = 0; i < diceValues.length; i++) {
            //     diceValues[i].dice.simulationRunning = true;
            //     diceValues[i].vectors = diceValues[i].dice.getCurrentVectors();
            //     diceValues[i].stableCount = 0;
            // }
            //
            // let check = () => {
            //     let allStable = true;
            //     for (let i = 0; i < diceValues.length; i++) {
            //         if (diceValues[i].dice.isFinished()) {
            //             diceValues[i].stableCount++;
            //         } else {
            //             diceValues[i].stableCount = 0;
            //         }
            //
            //         if (diceValues[i].stableCount < 50) {
            //             allStable = false;
            //         }
            //     }
            //
            //     if (allStable) {
            //         console.log("all stable");
            //         this.world.removeEventListener('postStep', check);
            //
            //         for (let i = 0; i < diceValues.length; i++) {
            //             //diceValues[i].dice.shiftUpperValue(diceValues[i].value);
            //             diceValues[i].dice.setVectors(diceValues[i].vectors);
            //             diceValues[i].dice.simulationRunning = false;
            //         }
            //
            //         this.throwRunning = false;
            //     } else {
            //         this.world.step(this.world.dt);
            //     }
            // };
            //
            // this.world.addEventListener('postStep', check);
        }

        resize(width: number, height: number) {

            var SCREEN_WIDTH = 368 * 2,
                SCREEN_HEIGHT = 344 * 2;

            var VIEW_ANGLE = 20,
                ASPECT = SCREEN_WIDTH / SCREEN_HEIGHT,
                NEAR = 0.01,
                FAR = 20000;

            this.camera = new THREE.PerspectiveCamera( VIEW_ANGLE, ASPECT, NEAR, FAR);
            //this.scene.add(this.camera);
            this.camera.position.set(0,0,35);
        }
    }

}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Dices/DiceManagerClass.ts